<template>
  <span class="badge" :class="$style.primary"><slot /></span>
</template>

<style module lang="scss">
@import "@/assets/_variables.scss";

.primary {
  --#{$prefix}badge-font-weight: normal;
  --#{$prefix}badge-font-size: 1em;
  background-color: #{$primary};
  color: white;
}
</style>
